import { api } from '../configs/axiosConfigs';
import { SignatureInput } from '../../utility/signature';

export const getSignature = async () => api.get('/signature');
export const saveSignature = async (input: SignatureInput) => api.put('/signature', input);
export const deleteSignature = async () => api.delete('/signature');
